/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1035
 */

"use strict"

var n = "object" == typeof global && global && global.Object === Object && global
exports.a = n
